import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <motion.a
    href="https://wa.me/393473275955"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.5, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-fuchsiabrand text-white flex items-center justify-center shadow-lg shadow-fuchsiabrand/30 hover:bg-magentadark transition-colors duration-300"
    aria-label="Scrivimi su WhatsApp"
  >
    <MessageCircle size={26} />
  </motion.a>
);
